import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { soDigitos } from '../components/formulario.utils';
import { cepQueries } from '../queries';

const DEBOUNCE_MS = 300;

export type FalhaCep = 'nao_encontrado' | 'indisponivel' | 'outro';

function motivo(error: unknown): FalhaCep {
  if (!isAxiosError(error)) return 'outro';
  const codigo = error.response?.data?.codigo;
  if (codigo === 'CEP_NAO_ENCONTRADO') return 'nao_encontrado';
  if (codigo === 'CEP_INDISPONIVEL' || !error.response) return 'indisponivel';
  return 'outro';
}

/** Busca de endereço pelo CEP (spec 10): só com `habilitado`, 8 dígitos e 300 ms sem digitar (R15). */
export function useConsultaCep({ cep, habilitado }: { cep: string; habilitado: boolean }) {
  const digitos = soDigitos(cep);
  const [estavel, setEstavel] = useState(digitos);
  useEffect(() => {
    const h = setTimeout(() => setEstavel(digitos), DEBOUNCE_MS);
    return () => clearTimeout(h);
  }, [digitos]);

  const ativo = habilitado && digitos.length === 8 && estavel === digitos;
  const q = useQuery({ ...cepQueries.porCep(estavel), enabled: ativo });
  return {
    endereco: ativo ? q.data : undefined,
    buscando: habilitado && digitos.length === 8 && (estavel !== digitos || q.isFetching),
    falha: ativo && q.isError ? motivo(q.error) : null,
  };
}
